module.exports = __webpack_public_path__ + "static/media/home-group-logo-charcoal.0f4b2f74.svg";